import { PERMISION } from "security"
import type { MenuType } from "../types"

export const assetManagementMenu = {
  menu: [
    {
      label: "REGISTER",
      link: "/asset-management/register",
      permission: PERMISION.ASET_MANAGEMENT.REGISTER.PERMISION
    },
    {
      label: "TRANSACTION",
      link: "#",
      permission: PERMISION.ASET_MANAGEMENT.TRANSACTION.PERMISION,
      children: [
        { label: "PROFILE ASSET", link: "/asset-management/transaction/profile-asset", permission: PERMISION.ASET_MANAGEMENT.TRANSACTION.PROFILE_ASSET.PERMISION },
        { label: "DEPRECIATION", link: "/asset-management/transaction/depreciation", permission: PERMISION.ASET_MANAGEMENT.TRANSACTION.DEPRECIATION.PERMISION },
      ]
    },
    {
      label: "REPORT",
      link: "#",
      permission: PERMISION.ASET_MANAGEMENT.REPORT.PERMISION
    },
    {
      label: "JOURNAL",
      link: "/asset-management/journal",
      permission: PERMISION.ASET_MANAGEMENT.JOURNAL.PERMISION
    },
    {
      label: "FIND",
      link: "/asset-management/find",
      permission: PERMISION.ASET_MANAGEMENT.FIND.PERMISION
    }
  ] as MenuType[]
}